module.exports = __webpack_public_path__ + "static/media/Stellar Ace King Headboard - 180 cm_Natural.5b3eaa80.png";